import { useEffect } from "react";
import { useAuth } from "./useAuth";
import Intercom from "@intercom/messenger-js-sdk";

const INTERCOM_APP_ID = "ll0leu0j";

export function useIntercom() {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      Intercom({
        app_id: INTERCOM_APP_ID,
        user_id: String(user.id),
        name: user.username || user.name || "User",
        email: user.email,
        created_at: user.createdAt
          ? Math.floor(new Date(user.createdAt).getTime() / 1000)
          : undefined,
        user_hash: (user as any).intercomHash || undefined,
      });
    } else {
      Intercom({
        app_id: INTERCOM_APP_ID,
      });
    }
  }, [isAuthenticated, user]);
}
